/** Created by azhou on 2019/2/15.*/
<template>
  <div :class="[type === 'textarea' ? '':'d-center']">
    <span v-if="leftText" :class="[required ? 'text-danger':'text-white','mr-small']">*</span>
    <div class="d-center" v-if="leftText"><div class="form-left-text" :style="{width:width+'px'}">{{leftText}}</div>：</div>
    <div class="  input-self" v-if="type!=='textarea'" style="text-align:left;">
      <div class="many-input" v-for="(item,index) in source" :key="index">
        <input :type="type" 
             :id="inputId"
             :class="appendText?'no-right':''"
             v-bind:value="item"
             :disabled="disabled"
             @input="inputs($event.target.value,index)"
             @blur="$emit('blur',$event.target.value)"
             @keyup.enter="$emit('enter',$event.target.value)"
             :placeholder="placeholder"/>
          <div class="many" :class="{'hs':source.length>=4}" @click="addSource" v-if="index==0"> <i class="el-icon-circle-plus"></i></div>
          <div class="many red"  @click="source.splice(index,1)" v-if="index!=0"><i class="el-icon-remove"></i></div>
      </div>
    </div>
  </div>  
</template>
<script>
  export default {
    name: 'LeftTextBorder',
    props: {
      value: {},
       width: {
        type: Number,
        default:100
      },
      type: {
        type: String,
        default: 'text'
      },
      leftText: {
        type: String,
      },
      placeholder: {
        type: String,
      },
      required: {
        type: Boolean,
        default: false
      },
      inputId: {                       //input id，用作百度地图自动完成的id指向
        type: String,
        default: ''
      },
      disabled: {
        type: Boolean,
        default: false
      },
      appendText: {}
    },
    data(){
      return {
        source:['']
      }
    },
    watch:{
      value: {
        handler(newVal, oldVal) {
          if(!newVal)return;
          this.source=this.valueInside=this.$verify.stitch(newVal);
        },
        immediate: true // 关键：初始时立即执行
      },
    },
    methods:{
      inputs(val,index){
        this.source[index]=val;
        this.inputData(this.source);
      },
      //添加多个
      addSource(){
        if(this.source.length>=4){return}
        this.source.push('');
        this.inputData(this.source);

      },
      //更新数据
      inputData(value){
        value=value.join(',');
        this.$emit('input',value);
        this.$emit('blur',value);
        this.$emit('enter',value)
      }
    }
  }
</script>
<style lang="scss" scoped>

  .narrow{
    input{
      height: 24px!important;
    }
  }
  .smallInput{
    height: 24px!important;
    line-height: 24px!important
  }
  .input-self {
    width: 100%;
    box-sizing: border-box;
    display: block;
    color: #606266;
    flex: 1;
    input,textarea{
      border: 1px solid #dcdfe6;
      padding: 3px 0px;
      appearance: none;
      width: 94%;
      padding: 0 3%;
      border-radius: 3px;
      font-size: 14px;
      line-height: 32px;
      &:focus{
        outline: none;
        border: 1px solid var(--smtc-color-primary);
      }
    }
    input{height: 31px;}
    textarea{
      height: 80px;
      resize: none;
    }
  }
  .append{
    background-color: #f5f7fa;
    vertical-align: middle;
    display: table-cell;
    position: relative;
    border: 1px solid #dcdfe6;
    border-left: 0;
    font-size: 14px;
    padding: 3px 0;
    border-radius: 4px;
    width: 60px;
    white-space: nowrap;
    height: 24px;
    line-height: 24px;
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
    text-align: center
  }
  .many{
    color: var(--smtc-color-primary); 
    margin-left: 6px;
    line-height: 32px;
    cursor: pointer;
  }
    .red{
    color: red;
  }
  .many-input{
    display: flex;
    margin-bottom: 6px;
  }
  .input-self .many-input:last-child{
    margin-bottom: 0;
  }
  .hs{
    color: #eee;
  }
</style>
